import { useLocation } from "react-router-dom";

import { toLegacyPath } from "../SitePath";

let currentPath: string | undefined;
let previousPath: string | undefined;

/**
 * Records the path the user was on before the current one. Called by the AppShell while it
 * renders - before the page below it - so pages can read where they were opened from.
 *
 * As the screens compare it: without the trailing slash, and a Keepo's address (/sites/<id>/settings) as its old
 * screen (/settings). An old address redirecting to the Keepo's is then the same screen, not one more.
 */
export const usePreviousPathTracker = () => {
  const location = useLocation();
  const pathname = toLegacyPath(location.pathname.length > 1 ? location.pathname.replace(/\/+$/, "") : "/");
  if (pathname !== currentPath) {
    previousPath = currentPath;
    currentPath = pathname;
  }
};

/** The path the user was on before the current screen, if any. */
export const getPreviousPath = () => previousPath;
